module.exports = [
  {
    value: null,
    text: 'Selecione um banco',
    disabled: true
  },
  { 
    value: {
      url:"http://samuel.3v3.farm",
    },
    text: 'Samuel',
    tags: [
      {text: 'EMR', color: 'orange'},
      {text: '$$$', color: 'red'},
    ]
  },
  { 
    value: {
      url:"http://meripobo.3v3.farm",
    },
    text: 'Meripobo Jaguaruana',
    tags: [
      {text: 'EMR', color: 'orange'},
      {text: '$$$', color: 'red'},
    ]
  },
  { 
    value: {
      url:"http://cir.3v3.farm",
    },
    text: 'Cir',
    tags: [
      {text: 'EMR', color: 'orange'},
      {text: '$$$', color: 'red'},
    ]
  },
  { 
    value: {
      url:"http://tapera.af.3v3.farm",
    },
    text: 'Tapera',
    tags: [
      {text: 'EMR', color: 'orange'},
      {text: '$$$', color: 'red'},
    ]
  },
  { 
    value: {
      url:"http://mf.3v3.farm",
    },
    text: 'Mata Fresca',
    tags: [
      {text: 'EMR', color: 'orange'},
      {text: '$$$', color: 'red'},
    ]
  },
  { 
    value: {
      url:"http://n8.3v3.farm",
    },
    text: 'N8',
    tags: [
      {text: 'EMR', color: 'orange'},
      {text: '$$$', color: 'red'},
    ]
  },
  { 
    value: {
      url:"http://neruda.3v3.farm",
    },
    text: 'Neruda',
    tags: [
      {text: 'EMR', color: 'orange'},
      {text: '$$$', color: 'red'},
    ]
  },
  { 
    value: {
      url:"http://praquio.af.3v3.farm",
    },
    text: 'Praquio',
    tags: [
      {text: 'EMR', color: 'orange'},
      {text: '$$$', color: 'red'},
    ]
  },
  { 
    value: {
      url:"http://backups.3v3.farm",
    },
    text: 'Backups',
    tags: [
      {text: 'EMR', color: 'orange'},
      {text: '$$$', color: 'red'},
    ]
  },
  {
    value: {
      url:"http://cir.3v3.farm",
      tags: [
        {text: 'EMR', color: 'orange'},
        {text: '$', color: 'green'},
      ]
    },
    text: 'Cir 3v3'
  },
  {
    value: {
      url:"http://software.local",
      tags: []
    },
    text: 'Software Local',
  },
  {
    value: {
      url:"http://software.3v3.farm",
      tags: []
    },
    text: 'Software Remoto',
  },
  {
    value: {
      url:"http://eb12.dinc.3v3.farm",
      tags: []
    },
    text: 'DINC EB12',
  },
  {
    value: {
      url:"http://summerville.3v3.farm",
      tags: []
    },
    text: 'Summervile',
  },
  {
    value: {
      url:"http://macacos.af.3v3.farm",
      tags: [
        {text: 'EMR', color: 'orange'},
        {text: '$$$', color: 'red'},
      ]
    },
    text: 'Macacos',
  },
  {
    value: {
      url:"http://santajulia.af.3v3.farm",
      tags: [
        {text: 'EMR', color: 'orange'},
        {text: '$$$', color: 'red'},
      ]
    },
    text: 'Santa Julia',
  },
  {
    value: {
      url:"http://rusbana.af.3v3.farm",
      tags: [
        {text: 'EMR', color: 'orange'},
        {text: '$$$', color: 'red'},
      ]
    },
    text: 'Rusbana',
  },
  {
    value: {
      url:"http://pauliceia.af.3v3.farm",
      tags: [
        {text: 'EMR', color: 'orange'},
        {text: '$$$', color: 'red'},
      ]
    },
    text: 'Pauliceia',
  },
  {
    value: {
      url:"http://flamengo.af.3v3.farm",
      tags: [
        {text: 'EMR', color: 'orange'},
        {text: '$$$', color: 'red'},
      ]
    },
    text: 'Flamengo',
  },
  {
    value: {
      url:"http://apodi.af.3v3.farm",
      tags: [
        {text: 'EMR', color: 'orange'},
        {text: '$$$', color: 'red'},
      ]
    },
    text: 'Apodi AF',
  },
  {
    value: {
      url:"http://apodi.mf.3v3.farm",
      tags: [
        {text: 'EMR', color: 'orange'},
        {text: '$$$', color: 'red'},
      ]
    },
    text: 'Apodi MF',
  },
  {
    value: {
      url:"http://rijkzwaan.3v3.farm",
      tags: [
        {text: 'EMR', color: 'orange'},
        {text: '$', color: 'green'},
      ]
    },
    text: 'Rijkzwaan',
  },
  {
    value: {
      url:"http://norfruit.3v3.farm",
    },
    text: 'Norfruit'
  },
  {
    value: {
      url:"http://frutosdosol.3v3.farm",
    },
    text: 'Frutos do Sol'
  },
  {
    value: {
      url:"http://topplant.3v3.farm",
    },
    text: 'Topplant'
  },
  {
    value: {
      url:"http://mf.3v3.farm",
    },
    text: 'MF 3021'
  },
  {
    value: {
      url: "http://central.af.3v3.farm",
      tags: [
        {text: 'EMR', color: 'orange'},
        {text: '$$$', color: 'red'},
      ],
    },
    text: 'Central',
  },
].sort((a, b) => a.text.localeCompare(b.text));